module.exports = __webpack_public_path__ + "media/meninger-helt-uenig-1nSab.svg";